import { render, staticRenderFns } from "./FormContact.vue?vue&type=template&id=4d2754ef&scoped=true&"
import script from "./FormContact.vue?vue&type=script&lang=js&"
export * from "./FormContact.vue?vue&type=script&lang=js&"
import style0 from "./FormContact.vue?vue&type=style&index=0&id=4d2754ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2754ef",
  null
  
)

export default component.exports